import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    currentRouteKey: "",
    isPageLoading: false,
    formDialog: false,
    allCoumnModal:false,
    serverSideEventProgress:0,
    serverSideEventErrors:[]
};

export const commonSlice = createSlice({
    name: "base/common",
    initialState,
    reducers: {
        toggleFormDialog: (state, action) => {
            state.formDialog = action.payload;
        },
        setCurrentRouteKey: (state, action) => {
            state.currentRouteKey = action.payload;
        },
        setIsPageLoading: (state, action) => {
            state.isPageLoading = action.payload;
        },
        setAllColumnModal:(state,action)=>
        {
            state.allCoumnModal = action.payload;
        },
        setServerSideEventProgress:(state,action)=>
        {
            state.serverSideEventProgress = action.payload
        },
        setServerSideEventError:(state,action)=>{
            state.serverSideEventErrors = action.payload
        }
    },
});

export const {toggleFormDialog, setCurrentRouteKey, setIsPageLoading,setAllColumnModal,setServerSideEventProgress,setServerSideEventError } = commonSlice.actions;

export default commonSlice.reducer;
